export const NAVY = '#2B3E8A';
export const BLUE = '#3B66B8';
export const CYAN = '#12785A';
export const TEAL = '#12785A';
export const BG = '#F3F2F9';
export const INK = '#3A3660';
export const INK_SOFT = '#6A6688';
export const LINE = '#EAE8F5';

/** Soft contrast gradient matching design reference */
export const GRAD =
  'linear-gradient(135deg, #3B66B8 0%, #8156B4 100%)';

export const FONT_DISPLAY = "'Plus Jakarta Sans', system-ui, sans-serif";
export const FONT_BODY = "'Plus Jakarta Sans', system-ui, sans-serif";

export const MAXW = 1200;
